import React from 'react';
import { MzcrServiceRequests } from '@meddihub/mzcr-ui';
import { getMzcrClient } from '../../../Mzcr/Services/mzcrClient';
import MzcrSubTabs, {
	MzcrSubTabView,
	MzcrSubTabsRenderArgs,
} from './MzcrSubTabs';

interface Props {
	/** Switches the patient card to the Profile tab (missing data for the MZČR registry). */
	onOpenProfile?: () => void;
}

const renderService = ({
	view,
	service,
	onViewChange,
	onNewReceivedCountChange,
}: MzcrSubTabsRenderArgs) => (
	<MzcrServiceRequests
		key={service.rid}
		mzcrClient={getMzcrClient()}
		{...service}
		view={view}
		onViewChange={onViewChange}
		onNewReceivedCountChange={onNewReceivedCountChange}
	/>
);

const INITIAL_VIEW: MzcrSubTabView = 'sent';

/**
 * eŽádanky (MZČR) in the patient card – sub-tabs "Nová eŽádanka", "Odeslané" and "Přijaté"
 * (designs E1–E9), each showing only this patient's requests.
 */
const PatientTreatmentServiceRequests: React.FC<Props> = ({
	onOpenProfile,
}) => (
	<MzcrSubTabs
		translationPrefix='patientTreatment.serviceRequests'
		initialView={INITIAL_VIEW}
		onOpenProfile={onOpenProfile}
		renderService={renderService}
	/>
);

export default PatientTreatmentServiceRequests;
